import React from "react"
import ReactDOM from "react-dom"
import MerchantPageContactUs from "./merchant-page-contact-us"

export default class MerchantPageContactUsModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.contactUsSettings = elem.dataset.contactUsSettings && JSON.parse(elem.dataset.contactUsSettings)
    self.currentPageJson = elem.dataset.currentPageJson && JSON.parse(elem.dataset.currentPageJson)
    self.otherLocations = elem.dataset.otherLocations && JSON.parse(elem.dataset.otherLocations)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(
      <MerchantPageContactUs
        {...self.modelJson}
        {...self.currentPageJson}
        otherLocations={self.otherLocations}
        contactUsSettings={self.contactUsSettings}
      />,
      self.elem,
    )
  }
}
